import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';

@Component({
  selector: 'app-comments',
  imports: [TranslateModule, UpperFirstLetterPipe],
  templateUrl: './comments.html',
  styleUrl: './comments.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Comments {}
